module.exports = __webpack_public_path__ + "static/media/1 40 selvsagt.e1d4ed3a.mp3";